// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__KIclT","row":"styles_row__24cDx"};